import { atom } from 'jotai'

export const contratoSeleccionado = atom(undefined);